import { render, staticRenderFns } from "./createmail.vue?vue&type=template&id=f99d3928&scoped=true&"
import script from "./createmail.vue?vue&type=script&lang=js&"
export * from "./createmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d3928",
  null
  
)

export default component.exports